module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-small-47ec010a50cf079d13a1909cecfcc0a2.png";